import React from 'react';
import { createRoot } from 'react-dom/client';
import { Web3ReactProvider } from '@web3-react/core';
import ErrorBoundary from './components/ErrorBoundary';
import { connectors } from './config/connectors';
import { SettingsProvider } from './hooks/useSettings';
import ThemeProvider from './theme';
import App from './App';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
const queryClient =   new QueryClient({
    defaultOptions: {
      queries: {
        suspense: false,
      },
    },
  }) 
root.render(
  <React.StrictMode>
   <QueryClientProvider client={queryClient}>
    <ErrorBoundary>
      <SettingsProvider>
        <ThemeProvider>
          <Web3ReactProvider connectors={connectors}>
            <App />
          </Web3ReactProvider>
        </ThemeProvider>
      </SettingsProvider>
    </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>
);